import { useCallback } from 'react';
import type { TopCollectionsRequestI } from '@tacans/shared-marketplace-layer';

import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { actions } from '../ducks/top-collections/top-collections.slice';
import { selectTopCollectionsEntities, selectTopCollectionsLoading } from '../ducks/top-collections/top-collections.selectors';
import { topCollectionsFetchThunk } from '../ducks/top-collections/top-collections.thunk';

export const useTopCollections = () => {
    const dispatch = useAppDispatch();

    const topCollections = useAppSelector(selectTopCollectionsEntities);
    const isLoading = useAppSelector(selectTopCollectionsLoading);

    const fetch = useCallback((request: TopCollectionsRequestI) => {
        dispatch(topCollectionsFetchThunk(request));
    }, [dispatch]);

    const clear = useCallback(() => {
        dispatch(actions.clear());
    }, [dispatch]);

    return { fetch, clear, topCollections, isLoading };
};
